/** @format */

import React from "react";
import OwlCarousel from "react-owl-carousel";

function Carousel1() {
  var settings = {
    autoplay: true,
    smartSpeed: 1500,
    loop: true,
    nav: false,
    dots: true,
    items: 1,
    dotsData: true,
  };
  return (
    <>
      <OwlCarousel
        className="owl-carousel header-carousel position-relative"
        loop
        margin={10}
        nav
        {...settings}
      >
        <div
          className="owl-carousel-item position-relative"
          data-dot="<img src='img/carousel-1.jpg'>"
        >
          <img className="img-fluid" src="img/carousel-1.jpg" alt="" />
          <div className="owl-carousel-inner">
            <div className="container">
              <div className="row justify-content-start">
                <div className="col-10 col-lg-8">
                  <h1 className="display-2 text-white animated slideInDown">
                    Pioneers Of Solar And Renewable Energy
                  </h1>
                  <p className="fs-5 fw-medium text-white mb-4 pb-3">
                    Solar and renewable energy have the potential to
                    revolutionize the way we power our world. But before we
                    could harness the power of the sun and wind, there were a
                    few pioneers who laid the foundation for the renewable
                    energy industry we know today. <br />
                    Here are a few of the pioneers of solar and renewable
                    energy:
                    <br />
                    Edmund Becquerel (1820-1891) <br />
                    French physicist Edmund Becquerel is credited with
                    discovering the photovoltaic effect, the principle behind
                    solar cells. In 1839, Becquerel noticed that when light
                    shone on a metal electrode immersed in an acidic solution,
                    an electric current flowed. This discovery paved the way for
                    the development of solar cells.
                    <br />
                  </p>
                  <a
                    href
                    className="btn btn-primary rounded-pill py-3 px-5 animated slideInLeft"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="owl-carousel-item position-relative"
          data-dot="<img src='img/carousel-2.jpg'>"
        >
          <img className="img-fluid" src="img/carousel-2.jpg" alt="" />
          <div className="owl-carousel-inner">
            <div className="container">
              <div className="row justify-content-start">
                <div className="col-10 col-lg-8">
                  <h1 className="display-2 text-white animated slideInDown">
                    Pioneers Of Solar And Renewable Energy
                  </h1>
                  <p className="fs-5 fw-medium text-white mb-4 pb-3">
                    Charles Fritts (1850-1907) <br /> American inventor Charles
                    Fritts created the first solar cell in 1883. Fritts' solar
                    cell was made of selenium coated with a thin layer of gold.
                    It was only 1% efficient, but it was a major breakthrough in
                    the development of solar technology. <br />
                    These are just a few of the many pioneers of solar and
                    renewable energy. Thanks to their work, we are now able to
                    harness the power of the sun and wind to power our homes and
                    businesses.
                    <br />
                  </p>
                  <a
                    href
                    className="btn btn-primary rounded-pill py-3 px-5 animated slideInLeft"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="owl-carousel-item position-relative"
          data-dot="<img src='img/carousel-3.jpg'>"
        >
          <img className="img-fluid" src="img/carousel-3.jpg" alt="" />
          <div className="owl-carousel-inner">
            <div className="container">
              <div className="row justify-content-start">
                <div className="col-10 col-lg-8">
                  <h1 className="display-2 text-white animated slideInDown">
                    Pioneers Of Solar And Renewable Energy
                  </h1>
                  <p className="fs-5 fw-medium text-white mb-4 pb-3">
                    Renewable energy is essential to our future. It is a clean,
                    sustainable source of energy that can help us to reduce our
                    reliance on fossil fuels and combat climate change. The
                    pioneers of solar and renewable energy have laid the
                    foundation for a brighter future, and we are all indebted to
                    their work.
                  </p>
                  <a
                    href
                    className="btn btn-primary rounded-pill py-3 px-5 animated slideInLeft"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </OwlCarousel>
      ;
    </>
  );
}

export default Carousel1;
